(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["owf-coach-directory"] && !Shopify.designMode) return;
  try {
    
  function initializeOwfCoachDirectory(root) {
    if (root.dataset.coachDirectoryReady === 'true') return;
    root.dataset.coachDirectoryReady = 'true';

    const grid = root.querySelector('[data-coach-grid]');
    const cards = Array.from(root.querySelectorAll('[data-coach-card]'));
    const filterButtons = Array.from(root.querySelectorAll('[data-coach-filter]'));
    const profileButtons = Array.from(root.querySelectorAll('[data-coach-open]'));
    const dialogs = Array.from(root.querySelectorAll('[data-coach-dialog]'));
    const emptyState = root.querySelector('[data-coach-empty]');

    if (grid) {
      cards
        .sort((firstCard, secondCard) => {
          const orderDifference = Number(firstCard.dataset.coachSort) - Number(secondCard.dataset.coachSort);
          return orderDifference || firstCard.dataset.coachName.localeCompare(secondCard.dataset.coachName);
        })
        .forEach((card) => grid.appendChild(card));
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedFilter = button.dataset.coachFilter;
        let visibleCount = 0;

        filterButtons.forEach((candidate) => {
          const isSelected = candidate === button;
          candidate.classList.toggle('is-active', isSelected);
          candidate.setAttribute('aria-pressed', String(isSelected));
        });

        cards.forEach((card) => {
          const programs = card.dataset.coachPrograms || '';
          const isVisible = selectedFilter === 'all' || programs.includes(selectedFilter);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (emptyState) emptyState.hidden = visibleCount !== 0;
      });
    });

    profileButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.coachOpen);
        if (!dialog) return;

        dialog.owfTrigger = button;
        document.documentElement.classList.add('owf-coach-dialog-open');

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });
    });

    dialogs.forEach((dialog) => {
      const closeButton = dialog.querySelector('[data-coach-close]');

      closeButton?.addEventListener('click', () => dialog.close());

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        if (!document.querySelector('[data-coach-dialog][open]')) {
          document.documentElement.classList.remove('owf-coach-dialog-open');
        }
        dialog.owfTrigger?.focus();
      });
    });
  }

  function initializeAllOwfCoachDirectories(scope = document) {
    scope.querySelectorAll('[data-coach-directory]').forEach(initializeOwfCoachDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllOwfCoachDirectories());
  } else {
    initializeAllOwfCoachDirectories();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllOwfCoachDirectories(event.target));

  } catch(e) { console.error(e); }
})();
})();
